import { render, staticRenderFns } from "./ScoreIcon.vue?vue&type=template&id=37bf2b46&"
import script from "./ScoreIcon.vue?vue&type=script&lang=ts&"
export * from "./ScoreIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreIcon.vue?vue&type=style&index=0&id=37bf2b46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports